export default __webpack_public_path__ + "2eb917276a16cb74a4587cb4c0c42960.webp";